import React from "react";
import { Link } from "react-router-dom";
import "./Motor.css";

import img6201 from "../images/motorcycle/motor-oil/6201/pictures_FF6201-1_green_front_1200.jpg";
import img6208 from "../images/motorcycle/motor-oil/6208/pictures_FF6208_1_green_front_1200_2.jpg";

const motorSections = [
  {
    id: "motorcycle-oils",
    title: "Motorbikes Oil",
    products: [
      { id: "6201", name: "FANFARO M-4T Plus", image: img6201 },
      { id: "6208", name: "FANFARO S-4T+ 20W-50", image: img6208 },

    ],
  },


];

const Motor = () => {
  return (
    <div className="car-v4-page">
      <br />
      <nav className="app-breadcrumb">
        <Link to="/">Home</Link>
        <span className="separator">›</span>
        <Link to="/products">Products</Link>
        <span className="separator">›</span>
        <span className="current">Engine oils for Motorbikes & Outboards</span>
      </nav>

      {motorSections.map((section) => (
        <section key={section.id} className="car-v4-section">
          <h2 className="car-v4-heading">{section.title}</h2>

          <div className="car-v4-grid">
            {section.products.map((product) => (
              <Link
                key={product.id}
                to={`/products/engine-oils-for-motorbikes-and-outboards/motor-oil/${section.id}/${product.id}`}
                className="car-v4-card"
              >
                <div className="car-v4-img">
                  <img src={product.image} alt={product.name} />
                </div>


                <div className="car-v4-content">
                  <span className="car-v4-name">{product.name}</span>
                  <span className="car-v4-arrow-wrap">
                    <span className="car-v4-arrow">→</span>
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default Motor;